import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default {

    connect(apiKey) {
        if (!apiKey) return;
        window.Pusher = Pusher;
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_KEY,
            cluster: 'mt1',
            useTLS: true,
            authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
            auth: { headers: { 'Authorization': 'Bearer ' + apiKey } },
        });
    },

}